import { createContext, useContext, useRef, type ReactNode } from "react";
import { Toast, type ToastMessage } from "primereact/toast";

interface ToastApi {
    success: (summary: string, detail?: string) => void;
    error: (summary: string, detail?: string) => void;
    info: (summary: string, detail?: string) => void;
}
const ToastContext = createContext<ToastApi | null>(null);

export function ToastProvider({ children }: { children: ReactNode }) {
    const ref = useRef<Toast>(null);
    const show = (severity: ToastMessage["severity"], summary: string, detail?: string) =>
        ref.current?.show({ severity, summary, detail, life: 4500 });
    return (
        <ToastContext.Provider
            value={{
                success: (summary, detail) => show("success", summary, detail),
                error: (summary, detail) => show("error", summary, detail),
                info: (summary, detail) => show("info", summary, detail),
            }}
        >
            <Toast ref={ref} position="top-center" />
            {children}
        </ToastContext.Provider>
    );
}

export function useToast() {
    const value = useContext(ToastContext);
    if (!value) throw new Error("useToast deve ser usado dentro de ToastProvider");
    return value;
}
